<template>
  <div class="survey-chats-route-bridge text-center py-3">
    <b-spinner
      v-if="opening"
      variant="primary"
    />
    <p class="text-muted mt-1 mb-0">
      جاري فتح المحادثات...
    </p>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

/**
 * Route bridge: /survey-chats opens the Facebook-style floating messenger
 * over the current app (does not replace the page layout with a full chat page).
 */
export default {
  name: 'SurveyChatsPage',
  components: { BSpinner },
  data() {
    return { opening: true }
  },
  mounted() {
    const chatId = this.$route.query.chatId || null
    this.$store.dispatch('surveyChatsUi/open', { chatId })
    // Go back if possible so messenger floats over previous page; else projects
    this.$nextTick(() => {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ name: 'projects' }).catch(() => {})
      }
      this.opening = false
    })
  },
}
</script>
